import { useState, useEffect, useRef } from 'react';
import { NavBar } from '../components/landing/NavBar';
import { HeroSection } from '../components/landing/HeroSection';
import { AboutSection } from '../components/landing/AboutSection';
import { HowItWorks } from '../components/landing/HowItWorks';
import { RacesSection } from '../components/landing/RacesSection';
import { FeaturesSection } from '../components/landing/FeaturesSection';
import { CommunitySection } from '../components/landing/CommunitySection';
import { FAQAccordion } from '../components/landing/FAQAccordion';
import { Footer } from '../components/landing/Footer';
import { LoginModal } from '../components/landing/LoginModal';

interface LandingPageProps {
  autoOpenLogin?: boolean;
}

export function LandingPage({ autoOpenLogin = false }: LandingPageProps) {
  const [loginOpen, setLoginOpen] = useState(false);
  const loginTriggerRef = useRef<HTMLButtonElement | null>(null);

  // Load Cinzel font on mount (lazy-loaded, only for landing page)
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // Auto-open login modal from ?login=true
  useEffect(() => {
    if (autoOpenLogin) {
      setLoginOpen(true);
    }
  }, [autoOpenLogin]);

  const handleLoginClick = () => {
    setLoginOpen(true);
  };

  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{ background: '#110f0d', color: '#f0e8dc', fontFamily: "'DM Sans', sans-serif", fontSize: 16, lineHeight: 1.7 }}
    >
      <style>{`html { scroll-behavior: smooth; }`}</style>

      <NavBar onLoginClick={handleLoginClick} />

      <main>
        <HeroSection onLoginClick={handleLoginClick} />
        <Divider />
        <AboutSection />
        <Divider />
        <HowItWorks />
        <Divider />
        <RacesSection />
        <Divider />
        <FeaturesSection />
        <Divider />
        <CommunitySection />
        <Divider />
        <FAQAccordion />
      </main>

      <Footer />

      {loginOpen && (
        <LoginModal
          onClose={() => setLoginOpen(false)}
          triggerRef={loginTriggerRef}
        />
      )}
    </div>
  );
}

function Divider() {
  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-12">
      <hr
        className="border-none h-px"
        style={{ background: 'linear-gradient(90deg, transparent, #2e2924, transparent)' }}
      />
    </div>
  );
}
